import { STR } from "../i18n.js";
import { useStore } from "../store.js";
import { Plus, X } from "./Icons.js";
import { NumberField, Panel } from "./ui-primitives.js";

export function WaypointEditor() {
  const { waypoints, lang, setWaypoint, addWaypoint, removeWaypoint } = useStore();
  const t = STR[lang];

  return (
    <Panel
      title={t.waypoints}
      action={
        <button className="btn btn-ghost" onClick={addWaypoint}>
          <Plus size={12} />
          {t.add}
        </button>
      }
    >
      <div className="wp-list">
        {waypoints.map((wp, i) => (
          <div key={i} className="wp-row">
            <div className="wp-num">{i + 1}</div>
            <NumberField
              value={wp.depth}
              min={0}
              max={200}
              suffix="m"
              onChange={(v) => setWaypoint(i, { depth: v })}
            />
            <NumberField
              value={wp.duration}
              min={0}
              max={600}
              suffix="min"
              onChange={(v) => setWaypoint(i, { duration: v })}
            />
            {waypoints.length > 1 ? (
              <button className="btn-icon danger" onClick={() => removeWaypoint(i)}>
                <X size={12} />
              </button>
            ) : (
              <span />
            )}
          </div>
        ))}
      </div>
    </Panel>
  );
}
